import { CommonModule } from '@angular/common';
import { NgTemplateOutlet } from '@angular/common';
import { Component, input } from '@angular/core';

import { TitleComponent } from '@camelot/ui';
import { TypedTemplateDirective } from '@camelot/utils';

import { RichText, RichTextChildren } from '../../../services/dto/types/rich-text';
import { LinkComponent } from '../link/link.component';
import { TextComponent } from '../text/text.component';

@Component({
  selector: 'cam-rich-text',
  templateUrl: './rich-text.component.html',
  styleUrls: ['./rich-text.component.scss'],
  imports: [CommonModule, TitleComponent, LinkComponent, TextComponent, TypedTemplateDirective, NgTemplateOutlet],
})
export class RichTextComponent {
  richText = input.required<RichText>();

  public readonly typeToken!: { childrenText: RichTextChildren[] };
}
